export default function toArray(value) {
  return value == null ? [] : [].concat(value);
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/yup/es/util/toArray.js
// module id = 1437
// module chunks = 0